package com.example.mystybag.sharedmodels.project.responseModels.reservations

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
class GetMyPosTransactionStatusResponseModel(
    val paymentStatus: String = "",
    val isFinal: Boolean = false
) : BaseResponseModel()
